import MerchantSettingsPayoutPage from '../../../components/merchant/settings/payout/MerchantSettingsPayoutPage'

export default function SettingsPayout() {
  return <MerchantSettingsPayoutPage />
}
